import { render, staticRenderFns } from "./outInform.vue?vue&type=template&id=4de885b8"
import script from "./outInform.vue?vue&type=script&lang=js"
export * from "./outInform.vue?vue&type=script&lang=js"
import style0 from "./outInform.vue?vue&type=style&index=0&id=4de885b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports